import { render } from "./PastProjectsList.vue?vue&type=template&id=4e04a300"
import script from "./PastProjectsList.vue?vue&type=script&lang=js"
export * from "./PastProjectsList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\Jesta\\Front\\Jesta-Group\\Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__